export default __webpack_public_path__ + "static/media/greaterflames.4267e9fc.png";